<template>
    <main>
        <div class="row">
            <div class="col-md-12">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="icons icon-news-middle"></i> Disciplinas</b></h2>
                </div>
            </div>
            <!--<div class="col-sm-6" v-if="!hasDisabled">
        <button class="btn btn-success uppercase pull-right" @click="openCreate()">
            Criar
        </button>
    </div>-->

            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Disciplina</th>
                                <th>Número de Questões</th>
                                <th>Número de Acertos</th>
                            </tr>
                        </thead>
                        <tbody  v-if="questoes">
                            <!--<tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">-->
                            <tr v-for="item in questoes" class="animated fadeIn">
                                <td>{{item.nome}}</td>
                                <td>{{item.numeroQuestoes}}</td>
                                <td>{{item.numeroAcertos}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <button type="button" class="btn btn-default" @click="onBack()">
                        <span>Voltar</span>
                    </button>
                </div>

            </div>
            
        </div>
    </main>
</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "details-acertos",
        mixins: [base],
        props: { testeId: Number },
        data: () => ({

            questoes: {},                        
        }),

        methods: {

            onBack: function () {
                this.$emit('on-back')
            },

        },

        mounted() {

            new Api('teste/GetTotalQuestoesAcertos').get({testeId:this.testeId}).then(data => {
                this.questoes = data.dataList;
                console.log("dados...",this.questoes);                
            }, err => { this.defaultErrorResult(err); })
            //new Api('candidato').get({ candidatoId: this.candidatoId }).then(data => {
            //    this.candidato = data.dataList[0];
            //}, err => { this.defaultErrorResult(err); })
        }
    };
</script>
